'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    caption1StrongerClassNames: function() {
        return caption1StrongerClassNames;
    },
    useCaption1StrongerStyles: function() {
        return useCaption1StrongerStyles;
    }
});
const _react = require("@griffel/react");
const caption1StrongerClassNames = {
    root: 'fui-Caption1Stronger'
};
const useCaption1StrongerStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fy9rknc",
        Bhrd7zp: "flh3ekv",
        Bg96gwp: "fwrc4pm"
    }
}, {
    d: [
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".flh3ekv{font-weight:var(--fontWeightBold);}",
        ".fwrc4pm{line-height:var(--lineHeightBase200);}"
    ]
});
